import React from 'react';
import DialogoGlobalCV from './controladorVista/dialogoGlobalCV';

const DialogoGlobal = () => <DialogoGlobalCV />;

export default DialogoGlobal;
